module.exports = __webpack_public_path__ + "img/run.5c45b961.png";